/**
 * The function calculates the booking fee based on the booking amount, fee percentage, and capped fee
 * amount.
 * @param {number} bookingAmount - The booking amount is the total amount of the booking
 * @param {number} feePercentage - The feePercentage parameter represents the percentage of the booking
 * amount that will be charged as a fee.
 * @param {number} cappedFeeAmount - The cappedFeeAmount parameter is the maximum amount of fee that
 * can be charged for a booking.
 */
export const calculateBookingFee = (
  bookingAmount: number,
  feePercentage: number,
  cappedFeeAmount: number,
): number => Math.min(bookingAmount * feePercentage, cappedFeeAmount);

export const getCreditsDeduction = (spendAmount: number, customerCredits: number): number => {
  if (customerCredits <= 0 || spendAmount <= 0) {
    return 0;
  }

  if (customerCredits >= spendAmount) {
    return spendAmount;
  }

  return customerCredits;
};

enum PromotionDeductionType {
  PERCENTAGE = "PERCENTAGE",
  ABSOLUTE = "ABSOLUTE",
}

interface PromotionGenericType {
  deductionType: string;
  deduction: number;
}

export const getPromotionDeduction = <T extends PromotionGenericType>(
  spendAmount: number,
  promotion?: T,
): number => {
  if (!promotion || spendAmount <= 0) {
    return 0;
  }

  const deductionType = promotion.deductionType.toUpperCase();

  if (deductionType === PromotionDeductionType.PERCENTAGE) {
    return Math.min(spendAmount * promotion.deduction * 0.01, spendAmount);
  }

  return Math.min(promotion.deduction, spendAmount);
};
